import { CommonAPI } from "../Client";
import { appendProcessedFile } from "../../../utils/imageUploadProcessor";

export const getWebsiteMetaDataAPI = (websiteId) => {
  return CommonAPI.get(`/website/meta-data?websiteId=${websiteId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getAllWebsiteMetaDataAPI = () => {
  return CommonAPI.get("/website/all/meta-data")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const createWebsiteMetaDataAPI = (payload) => {
  return CommonAPI.post(`/website/meta-data?websiteId=${payload?.websiteId || ""}`, payload?.dto)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateWebsiteMetaDataAPI = (payload) => {
  return CommonAPI.put("/website/meta-data", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteMetaDataAPI = (id) => {
  return CommonAPI.delete(`/website/meta-data?id=${id || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const uploadWebsiteMetaDataIconAPI = async (file) => {
  const formData = new FormData();
  await appendProcessedFile(formData, "file", file);

  return CommonAPI.post("/website/meta-data/icon", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteMetaDataIconAPI = (uploadId) => {
  return CommonAPI.delete(`/website/meta-data/icon?uploadId=${uploadId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};
